import { Link } from "@tanstack/react-router";

/**
 * New item card component.
 *
 * Displays a single NFT item listing with image and details.
 * Layout: image on left, details on right.
 *
 * @param {Object} props - Component props
 * @param {string} props.path1 - Link to item details page
 * @param {string} props.path2 - Link for "Buy Now" action
 * @param {string} props.path3 - Link to owner's profile
 * @param {string} props.img1 - Main item image URL
 * @param {string} props.img2 - Owner avatar URL
 * @param {string} props.text1 - Item subtitle/category
 * @param {string} props.text2 - Item name/title
 * @param {string} props.text3 - Item description
 * @param {string|number} props.price - Current price in SGB
 * @returns {React.ReactElement} NFT item card
 */
function Card({ path1 , path2 , path3 , img1 , img2 , text1 , text2 , text3 , price }){
  return(
      <div className="col-12 mb-15">
        <div className="card">
          <div className="card-body p-3">
            <div className="row">
              <div className="col-lg-6 text-center mt-lg-0">
                <div className="border-radius-lg h-100">
                  
                  <div className="position-relative d-flex align-items-center justify-content-center h-100">
                    <img className="w-100 position-relative z-index-2 border-radius-lg" alt="" src={img1} />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="d-flex flex-column h-100">
                  <p className="mb-1 pt-2">{text1}</p>
                  <Link className="text-decoration-none" to={path1}><h5 className="font-weight-bolder">{text2}</h5></Link>
                  <p>{text3}</p>
                  <p>
                    Current Price : <span className="gradient-text">{price} SGB</span>
                  </p>
                  <div className="d-flex align-items-center justify-content-between">
                    <Link to={path2}  className="btn btn-outline-primary btn-sm mb-0">Buy Now</Link>
                    <div className="avatar-group d-flex align-items-center">
                      <span className="mr-10 ">Item Owner:</span>
                      <Link to={path3} className="avatar avatar-xs rounded-circle" data-bs-toggle="tooltip" data-bs-placement="bottom" title="" data-bs-original-title="Nick Daniel">
                        <img className="rounded-circle" alt="placeholder" src={img2} />
                      </Link>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Card